import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Notification } from '../../../../shared/src/types/Notification';

export const notificationApi = createApi({
  reducerPath: 'notificationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'http://localhost:3001/api/notifications',
   credentials: 'include', 
  }),
  tagTypes: ['Notification'],
  endpoints: (builder) => ({
    getNotificationsByUserId: builder.query<Notification[], string>({
      query: (userId) => `/?user_id=${userId}`,
    }),

    addNotification: builder.mutation<Notification, Partial<Notification>>({
      query: (newNotification) => ({
        url: '/',
        method: 'POST',
        body: newNotification,
      }),
      invalidatesTags: ['Notification'],
    }),
    updateNotification: builder.mutation<Notification, { id: string; updates: Partial<Notification> }>({
      query: ({ id, updates }) => ({
        url: `/${id}`,
        method: 'PUT',
        body: updates,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Notification', id }],
    }),
    deleteNotification: builder.mutation<{ success: boolean }, string>({
      query: (id) => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Notification', id }],
    }),
  }),
});
export const {
  useGetNotificationsByUserIdQuery,
  useAddNotificationMutation,
  useUpdateNotificationMutation,
  useDeleteNotificationMutation,
} = notificationApi;
